import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {ProgressBar, Glyphicon, Button} from 'react-bootstrap'
import Dropzone from 'react-dropzone'
import firebase from '../firebase'
import * as helpers from '../lib/HelperFunctions'
import './css/IdeaImageField.css'
import Logger from '../stores/Logger'

class IdeaImageField extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ideaImageIsUploading: false,
            disableTrashButton: false,
            ideaImageProgress: 0,
            shouldShow: false,
            ideaImageTotalBytes: 0,
        }
    }
    onDropRejected(files) {
        console.error(files,'rejected!')
        this.props.onImageRejected(files[0])
    }
    onDropAccepted(files) {
        if(files.length===0){
            return
        }
        var uploadTask = firebase.storage().ref('ideas/ideasheet/illustrations').child(helpers.guid()).child(files[0].name).put(files[0])
        var ideaKey = this.props.ideaKey
        var whichFieldInDB = ''

        if(this.props.whichField === 'multipleImages'){
            // handling imageUrls
            whichFieldInDB = 'imageUrls'
            firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').set(true)
            //console.log('multipleImages', this.props.whichField, this.props.imageId)

        } else if(this.props.whichField === 'ideaImage') {
            // handling imageUrl
            whichFieldInDB = 'imageUrl'
            firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').set(true)
            //console.log('ideaImage', this.props.whichField)

        } else if(this.props.whichField === 'needImage') {
            // handling needImageUrl
            whichFieldInDB = 'needImageUrl'
            firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').set(true)
            //console.log('needImage', this.props.whichField)
        }
        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 90
            // console.log('Upload is ' + progress + '% done')
            this.setState({
                ideaImageProgress: progress,
                ideaImageTotalBytes: snapshot.totalBytes,
            })

            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                    console.log('Upload is paused')
                    break
                case firebase.storage.TaskState.RUNNING: // or 'running'
                    this.setState({
                        ideaImageIsUploading:true,
                    })
                    // console.log('Upload is running')
                    break

                default:
                    break

            }
        }, (error) => {
            Logger.trackEvent('imageUploadFailed', 'error', error)
            console.error(error)
            this.onDropRejected(files)
            this.setState({
                ideaImageIsUploading: false,
            })
            // // A full list of error codes is available at
            // // https://firebase.google.com/docs/storage/web/handle-errors
            // switch (error.code) {
            //     case 'storage/unauthorized':
            //     // User doesn't have permission to access the object
            //     break

            //     case 'storage/canceled':
            //     // User canceled the upload
            //     break

            //     case 'storage/unknown':
            //     // Unknown error occurred, inspect error.serverResponse
            //     break

            //     default:
            //     break
            // }
        }, () => {
            // Upload completed successfully
            Logger.trackEvent('imageUploaded', 'size', this.state.ideaImageTotalBytes)
            this.setState({
                ideaImageIsUploading: false,
                ideaImageProgress: 100,
                ideaImageTotalBytes: 0,
                disableTrashButton: true,
            })
            this.props.onNewImage(uploadTask.snapshot.downloadURL, uploadTask.snapshot.ref.bucket, uploadTask.snapshot.ref.fullPath, files[0].name, this.props.theKey)

            // Handling when to show the deletion button
            firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').on('value', snap => {
                if(snap.exists()){
                    let isUpLoading = snap.val()
                    if (isUpLoading === false){
                        this.setState({
                            ideaImageIsUploading: false,
                            ideaImageProgress: 100,
                            ideaImageTotalBytes: 0,
                            disableTrashButton: false,
                        })
                        firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').off()
                    }
                }
            })
            setTimeout(() => {
                firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').once('value').then(snap => {
                    if(snap.exists()){
                        if(snap.val() === true) {
                            this.setState({
                                ideaImageIsUploading: false,
                                ideaImageProgress: 100,
                                ideaImageTotalBytes: 0,
                                disableTrashButton: false,
                            })
                            firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').set(false)
                            firebase.database().ref().child('/ideas/'+ideaKey+'/'+whichFieldInDB+'_isUpLoading').off()
                        } else {
                            // console.log('timeout')
                        }
                    }
                })
            }, 30000)
        })
    }

    buttonState()
    {
        this.props.buttonState = true
    }

    render(){
        return (
            <div style={{height: this.props.fieldHeight+3}} className='imageFieldContainer'>
            {this.state.ideaImageIsUploading &&
                <ProgressBar active now={this.state.ideaImageProgress} className='imageProgressBar' />
            }
            <Dropzone
                accept='image/jpg, image/jpeg, image/png, image/gif'
                onDropAccepted={this.onDropAccepted.bind(this)}
                onDropRejected={this.onDropRejected.bind(this)}
                disablePreview={true}
                multiple={false}
                disableClick={(this.props.isUpLoading === true)}
                //maxSize={10000000}
                className='predo-imagefield'
                activeClassName='predo-imagefield accepted'
                rejectClassName='predo-imagefield rejected'
            >
                {this.props.imageUrl ? (
                    <div style={{height: this.props.fieldHeight}} className='ideaImageContainer'>
                        <img className='predo-image' style={{height: this.props.imageHeight+'%'}} onClick={(e) => this.props.fullscreenOption(e, this.props.whichField, this.props.imageId)} src={this.props.imageUrl} alt='Idea illustration' />
                    </div>
                ):(
                    <div style={{height: this.props.fieldHeight}} className='dragImageContainer'>
                        <p style={{marginTop: 10+'px'}} className='dragImageText'>
                            <Glyphicon glyph='download-alt' className='imageDropZoneText'/><br/>
                            Choose an image or drag it here
                        </p>
                    </div>
                )}
                {(this.props.imageUrl && (this.props.isUpLoading === false || this.props.isUpLoading === undefined)) &&
                <div className='imageFieldTrashButton'>
                    <Button onClick={(e) => this.props.handleImageDelete(this.props.theKey, e)}>
                        <Glyphicon className='imageFieldTrashIcon' glyph='trash'/>
                    </Button>
                </div>
                }
                {(this.props.imageUrl && this.props.isUpLoading === true) &&
                <div className='imageFieldLoad'>
                    <div>
                        <Glyphicon className='imageFieldHourGlass' glyph='hourglass' />
                    </div>
                </div>

                }
            </Dropzone>
            </div>
        )
    }
}
IdeaImageField.propTypes = {
    imageUrl: PropTypes.string,
    imageHeight: PropTypes.number.isRequired,
    imageId: PropTypes.number,
    onNewImage: PropTypes.func.isRequired,
    onImageRejected: PropTypes.func.isRequired,
    whichField: PropTypes.string.isRequired,
    fullscreenOption: PropTypes.func.isRequired,
    theKey: PropTypes.number.isRequired,
    fieldHeight: PropTypes.number.isRequired,
    allowButton: PropTypes.bool,
}

IdeaImageField.defaultProps = {
    allowButton: false,
}

export default IdeaImageField



// WEBPACK FOOTER //
// ./src/components/IdeaImageField.js